<article class="tile" [class.tile-pinned]="pinned">
  <div class="tile-header">
    <strong class="name" [title]="image.name">{{ image.name }}</strong>
    <span class="meta" [title]="image.date">{{ ageLabel }}</span>
  </div>
  <div class="picture" role="button" tabindex="0" [attr.aria-label]="'نمای بزرگ تصویر ' + image.name"
    (click)="zoom.emit()" (keydown.enter)="zoom.emit()" (keydown.space)="$event.preventDefault(); zoom.emit()">
    <img *ngIf="!imageFailed" [src]="imageSrc" [alt]="'تصویر ' + image.name" loading="lazy" (error)="onImageError()">
    <span class="category">{{ image.category === 'cabin' ? 'کابین' : 'بیرون' }}</span>
    <div class="image-badges">
      <span class="freshness" [class.fresh]="status === 'تازه'" [class.delayed]="status === 'تأخیردار'" [class.old]="status === 'قدیمی'">{{ status }}</span>
      <span *ngIf="pinned" class="pin-badge"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 3h6l-1 5 3 3v2H7v-2l3-3-1-5ZM12 13v8"/></svg>پین‌شده</span>
    </div>
    <span *ngIf="imageFailed" class="placeholder">تصویر در دسترس نیست</span>
  </div>
  <div class="tile-body">
    <div class="tile-footer">
      <span class="tile-speed">{{ image.speed == null || image.speed === '' ? 'سرعت نامشخص' : (image.speed | faNum) + ' km/h' }}</span>
    <div class="tile-actions">
      <button class="action-pin" type="button" [attr.aria-label]="pinned ? 'حذف پین' : 'پین کردن'" [attr.data-tooltip]="pinned ? 'حذف پین' : 'پین کردن'" [attr.aria-pressed]="pinned" (click)="pin.emit()">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 3h6l-1 5 3 3v2H7v-2l3-3-1-5ZM12 13v8"/></svg>
      </button>
      <button class="action-zoom" type="button" aria-label="نمای بزرگ" data-tooltip="نمای بزرگ" (click)="zoom.emit()">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 3H4v4M16 3h4v4M4 17v4h4m12-4v4h-4"/></svg>
      </button>
      <a class="action-camera" [routerLink]="['/surveillance', image.unitId]" target="_blank" rel="noopener" aria-label="نمایش دوربین" data-tooltip="نمایش دوربین">
        <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="6" width="18" height="13" rx="2"/><circle cx="12" cy="12.5" r="3"/><path d="M8 6l1-2h6l1 2"/></svg>
      </a>
      <a class="action-vehicle" [routerLink]="['/carInfo', image.unitId]" target="_blank" rel="noopener" aria-label="مشخصات خودرو" data-tooltip="مشخصات خودرو">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 10 2-5h10l2 5 1 2v5H4v-5l1-2Zm0 0h14M7 17v2m10-2v2M7 13h1m8 0h1"/></svg>
      </a>
    </div>
    </div>
  </div>
</article>
